// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Дополнительные стили для компонентов Ant Design - светлая тема */

/* Общие стили для контейнеров */
.page-container {
    width: 100%;
    padding: 15px;
  }
  
  /* Карточки и заголовки */
  .ant-card {
    margin-bottom: 20px;
    background-color: #ffffff !important;
    border: 1px solid #e8e8e8 !important;
    color: #333333 !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    max-width: 1000px !important;
  }
  .ant-card.ant-card-bordered.css-dev-only-do-not-override-1w9zx9j{
    max-width: 1000px !important;
  }
  
  .ant-card-head {
    background-color: #ffffff !important;
    border-bottom: 1px solid #e8e8e8 !important;
    color: #333333 !important;
  }
  
  .ant-card-body {
    padding: 20px !important;
  }
  
  .ant-typography {
    color: #333333 !important;
  }
  
  /* Стили для форм */
  .ant-form-item-label > label {
    color: #333333 !important;
    font-weight: 500;
  }
  
  .ant-form-item-explain-error {
    color: #e74c3c !important;
  }
  
  /* Поля ввода */
  .ant-input,
  .ant-input-number,
  .ant-picker,
  .ant-select-selector {
    background-color: #ffffff !important;
    border: 1px solid #d9d9d9 !important;
    color: #333333 !important;
  }
  
  .ant-input:focus,
  .ant-input-number:focus,
  .ant-picker:focus,
  .ant-select-selector:focus {
    border-color: #1abc9c !important;
    box-shadow: 0 0 0 2px rgba(26, 188, 156, 0.2) !important;
  }
  
  .ant-select-dropdown {
    background-color: #ffffff !important;
    border-radius: 4px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
  }
  
  .ant-select-item {
    color: #333333 !important;
  }
  
  .ant-select-item-option-selected {
    background-color: #e6f7ff !important;
    color: #333333 !important;
  }
  
  /* Кнопки */
  .ant-btn-primary {
    background-color: #2868f1 !important;
    border-color: #2868f1 !important;
    color: white !important;
  }
  
  .ant-btn-primary:hover {
    background-color: #2868f1 !important;
    border-color: #2868f1 !important;
  }
  
  .ant-btn-primary.ant-btn-dangerous {
    background-color: #e74c3c !important;
    border-color: #e74c3c !important;
    color: white !important;
  }
  
  .ant-btn-primary.ant-btn-dangerous:hover {
    background-color: #c0392b !important;
    border-color: #c0392b !important;
  }
  
  .ant-btn-dashed {
    color: #1abc9c !important;
    border-color: #1abc9c !important;
  }
  
  .ant-btn-dashed:hover {
    color: #16a085 !important;
    border-color: #16a085 !important;
  }
  
  /* Таблицы */
  .ant-table {
    background-color: #ffffff !important;
    color: #333333 !important;
  }
  
  .ant-table-thead > tr > th {
    background-color: #f5f5f5 !important;
    color: #333333 !important;
    border-bottom: 1px solid #e8e8e8 !important;
    font-weight: 600;
  }
  
  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #e8e8e8 !important;
    color: #333333 !important;
  }
  
  .ant-table-tbody > tr:hover > td {
    background-color: #f0f7fa !important;
  }
  
  .ant-table-row {
    background-color: #ffffff !important;
  }
  
  /* Пагинация */
  .ant-pagination-item {
    background-color: #ffffff !important;
    border-color: #d9d9d9 !important;
  }
  
  .ant-pagination-item a {
    color: #333333 !important;
  }
  
  .ant-pagination-item-active {
    background-color: #1abc9c !important;
    border-color: #1abc9c !important;
  }
  
  .ant-pagination-item-active a {
    color: rgb(73, 72, 72) !important;
  }
  
  .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination-next .ant-pagination-item-link {
    background-color: #ffffff !important;
    color: #333333 !important;
    border-color: #d9d9d9 !important;
  }
  
  .ant-pagination-disabled .ant-pagination-item-link {
    color: #d9d9d9 !important;
    background-color: #f5f5f5 !important;
    border-color: #d9d9d9 !important;
  }
  
  /* Сворачиваемые панели */
  .ant-collapse {
    background-color: #ffffff !important;
    border: 1px solid #e8e8e8 !important;
  }
  
  .ant-collapse-item {
    border-bottom: 1px solid #e8e8e8 !important;
  }
  
  .ant-collapse-header {
    color: #333333 !important;
    background-color: #f5f5f5 !important;
  }
  
  .ant-collapse-content {
    background-color: #ffffff !important;
    color: #333333 !important;
    border-top: 1px solid #e8e8e8 !important;
  }
  
  .ant-collapse-content-box {
    background-color: #ffffff !important;
    color: #333333 !important;
  }
  
  /* Разделитель */
  .ant-divider {
    border-color: #e8e8e8 !important;
  }
  
  /* Уведомления */
  .ant-message-notice-content {
    background-color: #ffffff !important;
    color: #333333 !important;
    border-radius: 4px !important;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2) !important;
  }
  
  .ant-message-success .anticon {
    color: #1abc9c !important;
  }
  
  .ant-message-error .anticon {
    color: #e74c3c !important;
  }
  
  /* Модальные окна */
  .ant-modal-content {
    background-color: #ffffff !important;
    color: #333333 !important;
  }
  
  .ant-modal-header {
    background-color: #ffffff !important;
    border-bottom: 1px solid #e8e8e8 !important;
  }
  
  .ant-modal-title {
    color: #333333 !important;
  }
  
  .ant-modal-close-x {
    color: #333333 !important;
  }
  
  .ant-modal-footer {
    border-top: 1px solid #e8e8e8 !important;
  }
  
  /* Подтверждение удаления */
  .ant-popover-inner {
    background-color: #ffffff !important;
    color: #333333 !important;
  }
  
  .ant-popover-title {
    color: #333333 !important;
  }
  
  .ant-popover-inner-content {
    color: #333333 !important;
  }
  td.ant-table-cell.ant-table-column-sort{
    background-color: #ffffff;
  }

  
  /* Адаптивность для мобильных устройств */
  @media (max-width: 768px) {
    .ant-table {
      overflow-x: auto;
    }
    
    .ant-form-item {
      margin-bottom: 16px;
    }
    
    .ant-card-body {
      padding: 16px !important;
    }
  }

`, "",{"version":3,"sources":["webpack://./src/styles/antd-custom.css"],"names":[],"mappings":"AAAA,mEAAmE;;AAEnE,gCAAgC;AAChC;IACI,WAAW;IACX,aAAa;EACf;;EAEA,yBAAyB;EACzB;IACE,mBAAmB;IACnB,oCAAoC;IACpC,oCAAoC;IACpC,yBAAyB;IACzB,wCAAwC;IACxC,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;;EAEA;IACE,oCAAoC;IACpC,2CAA2C;IAC3C,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,mBAAmB;EACnB;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,eAAe;EACf;;;;IAIE,oCAAoC;IACpC,oCAAoC;IACpC,yBAAyB;EAC3B;;EAEA;;;;IAIE,gCAAgC;IAChC,wDAAwD;EAC1D;;EAEA;IACE,oCAAoC;IACpC,6BAA6B;IAC7B,oDAAoD;EACtD;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;EAC3B;;EAEA,WAAW;EACX;IACE,oCAAoC;IACpC,gCAAgC;IAChC,uBAAuB;EACzB;;EAEA;IACE,oCAAoC;IACpC,gCAAgC;EAClC;;EAEA;IACE,oCAAoC;IACpC,gCAAgC;IAChC,uBAAuB;EACzB;;EAEA;IACE,oCAAoC;IACpC,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA,YAAY;EACZ;IACE,oCAAoC;IACpC,yBAAyB;EAC3B;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;IACzB,2CAA2C;IAC3C,gBAAgB;EAClB;;EAEA;IACE,2CAA2C;IAC3C,yBAAyB;EAC3B;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;EACtC;;EAEA,cAAc;EACd;IACE,oCAAoC;IACpC,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,oCAAoC;IACpC,gCAAgC;EAClC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;;IAEE,oCAAoC;IACpC,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;IACzB,oCAAoC;IACpC,gCAAgC;EAClC;;EAEA,yBAAyB;EACzB;IACE,oCAAoC;IACpC,oCAAoC;EACtC;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,yBAAyB;IACzB,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;IACzB,wCAAwC;EAC1C;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;EAC3B;;EAEA,gBAAgB;EAChB;IACE,gCAAgC;EAClC;;EAEA,gBAAgB;EAChB;IACE,oCAAoC;IACpC,yBAAyB;IACzB,6BAA6B;IAC7B,mDAAmD;EACrD;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,mBAAmB;EACnB;IACE,oCAAoC;IACpC,yBAAyB;EAC3B;;EAEA;IACE,oCAAoC;IACpC,2CAA2C;EAC7C;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,wCAAwC;EAC1C;;EAEA,2BAA2B;EAC3B;IACE,oCAAoC;IACpC,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;;;EAGA,yCAAyC;EACzC;IACE;MACE,gBAAgB;IAClB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,wBAAwB;IAC1B;EACF","sourcesContent":["/* Дополнительные стили для компонентов Ant Design - светлая тема */\r\n\r\n/* Общие стили для контейнеров */\r\n.page-container {\r\n    width: 100%;\r\n    padding: 15px;\r\n  }\r\n  \r\n  /* Карточки и заголовки */\r\n  .ant-card {\r\n    margin-bottom: 20px;\r\n    background-color: #ffffff !important;\r\n    border: 1px solid #e8e8e8 !important;\r\n    color: #333333 !important;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n    max-width: 1000px !important;\r\n  }\r\n  .ant-card.ant-card-bordered.css-dev-only-do-not-override-1w9zx9j{\r\n    max-width: 1000px !important;\r\n  }\r\n  \r\n  .ant-card-head {\r\n    background-color: #ffffff !important;\r\n    border-bottom: 1px solid #e8e8e8 !important;\r\n    color: #333333 !important;\r\n  }\r\n  \r\n  .ant-card-body {\r\n    padding: 20px !important;\r\n  }\r\n  \r\n  .ant-typography {\r\n    color: #333333 !important;\r\n  }\r\n  \r\n  /* Стили для форм */\r\n  .ant-form-item-label > label {\r\n    color: #333333 !important;\r\n    font-weight: 500;\r\n  }\r\n  \r\n  .ant-form-item-explain-error {\r\n    color: #e74c3c !important;\r\n  }\r\n  \r\n  /* Поля ввода */\r\n  .ant-input,\r\n  .ant-input-number,\r\n  .ant-picker,\r\n  .ant-select-selector {\r\n    background-color: #ffffff !important;\r\n    border: 1px solid #d9d9d9 !important;\r\n    color: #333333 !important;\r\n  }\r\n  \r\n  .ant-input:focus,\r\n  .ant-input-number:focus,\r\n  .ant-picker:focus,\r\n  .ant-select-selector:focus {\r\n    border-color: #1abc9c !important;\r\n    box-shadow: 0 0 0 2px rgba(26, 188, 156, 0.2) !important;\r\n  }\r\n  \r\n  .ant-select-dropdown {\r\n    background-color: #ffffff !important;\r\n    border-radius: 4px !important;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;\r\n  }\r\n  \r\n  .ant-select-item {\r\n    color: #333333 !important;\r\n  }\r\n  \r\n  .ant-select-item-option-selected {\r\n    background-color: #e6f7ff !important;\r\n    color: #333333 !important;\r\n  }\r\n  \r\n  /* Кнопки */\r\n  .ant-btn-primary {\r\n    background-color: #2868f1 !important;\r\n    border-color: #2868f1 !important;\r\n    color: white !important;\r\n  }\r\n  \r\n  .ant-btn-primary:hover {\r\n    background-color: #2868f1 !important;\r\n    border-color: #2868f1 !important;\r\n  }\r\n  \r\n  .ant-btn-primary.ant-btn-dangerous {\r\n    background-color: #e74c3c !important;\r\n    border-color: #e74c3c !important;\r\n    color: white !important;\r\n  }\r\n  \r\n  .ant-btn-primary.ant-btn-dangerous:hover {\r\n    background-color: #c0392b !important;\r\n    border-color: #c0392b !important;\r\n  }\r\n  \r\n  .ant-btn-dashed {\r\n    color: #1abc9c !important;\r\n    border-color: #1abc9c !important;\r\n  }\r\n  \r\n  .ant-btn-dashed:hover {\r\n    color: #16a085 !important;\r\n    border-color: #16a085 !important;\r\n  }\r\n  \r\n  /* Таблицы */\r\n  .ant-table {\r\n    background-color: #ffffff !important;\r\n    color: #333333 !important;\r\n  }\r\n  \r\n  .ant-table-thead > tr > th {\r\n    background-color: #f5f5f5 !important;\r\n    color: #333333 !important;\r\n    border-bottom: 1px solid #e8e8e8 !important;\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .ant-table-tbody > tr > td {\r\n    border-bottom: 1px solid #e8e8e8 !important;\r\n    color: #333333 !important;\r\n  }\r\n  \r\n  .ant-table-tbody > tr:hover > td {\r\n    background-color: #f0f7fa !important;\r\n  }\r\n  \r\n  .ant-table-row {\r\n    background-color: #ffffff !important;\r\n  }\r\n  \r\n  /* Пагинация */\r\n  .ant-pagination-item {\r\n    background-color: #ffffff !important;\r\n    border-color: #d9d9d9 !important;\r\n  }\r\n  \r\n  .ant-pagination-item a {\r\n    color: #333333 !important;\r\n  }\r\n  \r\n  .ant-pagination-item-active {\r\n    background-color: #1abc9c !important;\r\n    border-color: #1abc9c !important;\r\n  }\r\n  \r\n  .ant-pagination-item-active a {\r\n    color: rgb(73, 72, 72) !important;\r\n  }\r\n  \r\n  .ant-pagination-prev .ant-pagination-item-link,\r\n  .ant-pagination-next .ant-pagination-item-link {\r\n    background-color: #ffffff !important;\r\n    color: #333333 !important;\r\n    border-color: #d9d9d9 !important;\r\n  }\r\n  \r\n  .ant-pagination-disabled .ant-pagination-item-link {\r\n    color: #d9d9d9 !important;\r\n    background-color: #f5f5f5 !important;\r\n    border-color: #d9d9d9 !important;\r\n  }\r\n  \r\n  /* Сворачиваемые панели */\r\n  .ant-collapse {\r\n    background-color: #ffffff !important;\r\n    border: 1px solid #e8e8e8 !important;\r\n  }\r\n  \r\n  .ant-collapse-item {\r\n    border-bottom: 1px solid #e8e8e8 !important;\r\n  }\r\n  \r\n  .ant-collapse-header {\r\n    color: #333333 !important;\r\n    background-color: #f5f5f5 !important;\r\n  }\r\n  \r\n  .ant-collapse-content {\r\n    background-color: #ffffff !important;\r\n    color: #333333 !important;\r\n    border-top: 1px solid #e8e8e8 !important;\r\n  }\r\n  \r\n  .ant-collapse-content-box {\r\n    background-color: #ffffff !important;\r\n    color: #333333 !important;\r\n  }\r\n  \r\n  /* Разделитель */\r\n  .ant-divider {\r\n    border-color: #e8e8e8 !important;\r\n  }\r\n  \r\n  /* Уведомления */\r\n  .ant-message-notice-content {\r\n    background-color: #ffffff !important;\r\n    color: #333333 !important;\r\n    border-radius: 4px !important;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2) !important;\r\n  }\r\n  \r\n  .ant-message-success .anticon {\r\n    color: #1abc9c !important;\r\n  }\r\n  \r\n  .ant-message-error .anticon {\r\n    color: #e74c3c !important;\r\n  }\r\n  \r\n  /* Модальные окна */\r\n  .ant-modal-content {\r\n    background-color: #ffffff !important;\r\n    color: #333333 !important;\r\n  }\r\n  \r\n  .ant-modal-header {\r\n    background-color: #ffffff !important;\r\n    border-bottom: 1px solid #e8e8e8 !important;\r\n  }\r\n  \r\n  .ant-modal-title {\r\n    color: #333333 !important;\r\n  }\r\n  \r\n  .ant-modal-close-x {\r\n    color: #333333 !important;\r\n  }\r\n  \r\n  .ant-modal-footer {\r\n    border-top: 1px solid #e8e8e8 !important;\r\n  }\r\n  \r\n  /* Подтверждение удаления */\r\n  .ant-popover-inner {\r\n    background-color: #ffffff !important;\r\n    color: #333333 !important;\r\n  }\r\n  \r\n  .ant-popover-title {\r\n    color: #333333 !important;\r\n  }\r\n  \r\n  .ant-popover-inner-content {\r\n    color: #333333 !important;\r\n  }\r\n  td.ant-table-cell.ant-table-column-sort{\r\n    background-color: #ffffff;\r\n  }\r\n\r\n  \r\n  /* Адаптивность для мобильных устройств */\r\n  @media (max-width: 768px) {\r\n    .ant-table {\r\n      overflow-x: auto;\r\n    }\r\n    \r\n    .ant-form-item {\r\n      margin-bottom: 16px;\r\n    }\r\n    \r\n    .ant-card-body {\r\n      padding: 16px !important;\r\n    }\r\n  }\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
